"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScreenShareHintModal = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactSdk = require("@100mslive/react-sdk");
var _reactUi = require("@100mslive/react-ui");
var _DialogContent = require("../primitives/DialogContent");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ScreenShareHintModal = function ScreenShareHintModal(_ref) {
  var onClose = _ref.onClose;
  var hmsActions = (0, _reactSdk.useHMSActions)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Dialog.Root, {
    defaultOpen: true,
    onOpenChange: function onOpenChange(value) {
      return !value && onClose();
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_DialogContent.DialogContent, {
      title: "AudioOnly Screenshare",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        src: "/share-audio.png",
        alt: "AudioOnly Screenshare instructions"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DialogContent.DialogRow, {
        justify: "end",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Button, {
          variant: "primary",
          onClick: function onClick() {
            hmsActions.setScreenShareEnabled(true, true);
            onClose();
          },
          "data-testid": "audio_screenshare_continue",
          children: "Continue"
        })
      })]
    })
  });
};
exports.ScreenShareHintModal = ScreenShareHintModal;